import React, { useEffect, useRef, useState } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";
import map from "../../../../assets/images/map.svg";
import axios from "axios";
import BlogCard from "./blogCard";

function Hero() {
  const [blogs, setBlogs] = useState([]); // State to store project data
  const [loading, setLoading] = useState(true); // State to manage loading state
  const [error, setError] = useState(null); // State to manage error messages
  let letterRef = useRef(null);

  useEffect(() => {
    gsap.registerPlugin(ScrollTrigger);

    // Get all the letter elements inside letterRef
    const letters = letterRef.current.querySelectorAll("[data-char]");

    // Animate each letter from the top to its position
    gsap.fromTo(
      letters,
      {
        y: -50, // animate from 50px above
        opacity: 0,
      },
      {
        y: 0, // animate to original position
        opacity: 1,
        stagger: 0.1,
        duration: 1,
        ease: "power3.out",
        scrollTrigger: {
          trigger: letterRef.current,
          start: "top 75%",
        },
      }
    );

    const fetchBlogs = async () => {
        try {
          const response = await axios.get("http://localhost:9000/api/blogs/blogslist");
          setBlogs(response.data.data); // Update state with project data
        } catch (error) {
          console.error("Error fetching Blogs:", error);
          setError("Failed to fetch blogs");
        } finally {
          setLoading(false); // Update loading state
        }
      };
    
      fetchBlogs(); // Call fetch function on component mount
  }, []);

  useEffect(() => {
    console.log(blogs,"blog")
  }, [blogs])
  

  return (
    <div className="md:pt-20 pt-0 p-4 overflow-hidden relative container mx-auto">
      <div className="lg:flex flex-row">
        <div className="flex flex-row z-10 lg:gap-4 gap-0 px-4 lg:px-0 items-start text-left">
          <div className="w-1 mt-2 h-9 bg-[#ffc107]"></div>
          <div className="flex flex-col gap-1 items-start">
            <span className="lg:text-5xl text-2xl font-bold text-fontPrimary leading-normal">
                Insights & Innovations
            </span>

            <div>
              <h3  
              // Blog Posts
                className="flex flex-row gap-1 overflow-hidden lg:text-5xl text-2xl pb-2 leading-relaxed font-bold text-[#ffc107]"
                ref={letterRef}
              >
                <div data-char="o">O</div>
                <div data-char="u">u</div>
                <div data-char="r">r</div>
                <div data-char="l" style={{ marginLeft: "10px" }}>L</div>
                <div data-char="a">a</div>
                <div data-char="t">t</div>
                <div data-char="e">e</div>
                <div data-char="s">s</div>
                <div data-char="t">t</div>
                <div data-char="b" style={{ marginLeft: "10px" }}>B</div>
                <div data-char="l">l</div>
                <div data-char="o">o</div>
                <div data-char="g">g</div>
                <div data-char="P" style={{ marginLeft: "10px" }}>P</div>
                <div data-char="o">o</div>
                <div data-char="s">s</div>
                <div data-char="t">t</div>

              </h3>
            </div>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 py-20">
        {blogs.map((item, index) => (
          <div className=" min-h-fit border-none" key={index}>
            <BlogCard
              item={item}
              index={index}
              title={item.title}
              logo={item.image}
              web={item.web}
              app={item.app}
              activeColor={item.activeColor}
            />
          </div>
        ))}
      </div>
    </div>
  );
}

export default Hero;
